<script setup lang="ts">
import ElButton from '@/ElButton.vue';
import ElTabGroup from '@/ElTabGroup.vue';
import ElInputText from '@/forms/ElInputText.vue';

defineProps<{
  headline?: string;
  action?: Pick<InstanceType<(typeof ElTabGroup)['$props']>, 'label'> & { onClick?: () => void };
  tabs?: InstanceType<(typeof ElTabGroup)['$props']>;
  input?: InstanceType<(typeof ElInputText)['$props']>;
}>();

const emit = defineEmits<{
  (e: 'update:tabs', tabs: InstanceType<(typeof ElTabGroup)['$props']>): void;
  (e: 'update:input', tabs: InstanceType<(typeof ElInputText)['$props']>): void;
}>();
</script>
<template>
  <div class="min-w-72 px-4 py-5 bg-white inline-flex h-full flex-col gap-5">
    <div v-if="headline || action" class="h-10 flex items-center text-neutral-darker">
      <span v-if="headline" class="text-xl font-semibold text-ellipsis text-">{{ headline }}</span>
      <ElButton v-if="action" class="ml-auto" :label="action.label" variant="tertiary" size="xs" @click="action.onClick" />
    </div>
    <ElTabGroup v-if="tabs" v-bind="tabs" @update:model-value="modelValue => emit('update:tabs', { ...tabs, modelValue })" />
    <ElInputText v-if="input" v-bind="input" @update:model-value="modelValue => emit('update:input', { ...input, modelValue })" />
    <div class="h-full rounded-lg">
      <slot></slot>
    </div>
  </div>
</template>
